import { Navbar } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';


function NavBar(){
     
   return(
 
    <Navbar expand="md" variant="dark" id="navbar">
    <Navbar.Brand href="#home" className="mr-auto mt-3 px-3 port">Portfolio<span className="dot">.</span></Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto mr-5 px-3 mt-4">
            <Nav.Link className="mx-3 px-3 navlink" href="#home">Home</Nav.Link>
            <Nav.Link className="mx-3 px-3 navlink" href="#about">About</Nav.Link>
            <Nav.Link className="mx-3 px-3 navlink" href="#skills">Skills</Nav.Link>
            <Nav.Link className="mx-3 px-3 navlink" href="#projects">Projects</Nav.Link>
            <Nav.Link className="mx-3 px-3 con" href="#contact">Contact</Nav.Link>
        </Nav>
</Navbar.Collapse>
</Navbar>  

);
}

export default NavBar;